import mohitImage from '../assets/images/Mohit.png';
import ayushkumarImage from '../assets/images/ayush.jpg';
import deepakImage from '../assets/images/deepak.jpg';
import deepikabhardwajImage from '../assets/images/deepika.jpg';

const teamMembers = [
  {
    name: 'Mohit Jangra',
    role: 'Founder & Lead Architect',
    imageUrl: mohitImage,
    linkedin: 'https://www.linkedin.com/in/mohit-jangra-255764261/',
    email: 'mjsg46000@gmail.com',
    portfolio: 'https://mohitjangra.vercel.app/'
  },
  {
    name: 'Deepak Kumar',
    role: 'Frontend Developer',
    imageUrl: deepakImage,
    linkedin: 'https://www.linkedin.com/in/deepak-kumar-0a6149311/',
    email: 'ankitsaini1706@gmail.com',
    portfolio: 'https://deepakkumar1706.vercel.app/'
  },
  {
    name: 'Ayush Kumar',
    role: 'Full Stack Developer',
    imageUrl: ayushkumarImage,
    linkedin: 'https://www.linkedin.com/in/ayush08k/',
    email: 'ayushkumar2467@gmail.com',
    portfolio: 'https://ayushKumar.dev'
  },
  {
    name: 'Deepika Bhardwaj',
    role: 'AI/ML Engineer',
    imageUrl: deepikabhardwajImage,
    linkedin: 'https://www.linkedin.com/in/deepika-bhardwaj-4a6037238/',
    email: 'mb4490322@gmail.com',
    portfolio: 'https://deepikabhardwaj.dev'
  }
];

const AboutSection = () => (
  <section id="about" className="relative py-20 px-6 z-10">
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-16">
        <p className="text-sm uppercase tracking-[0.3em] text-indigo-300">About Visptech</p>
        <h2 className="text-4xl md:text-5xl font-bold text-white mt-4">Technology Crafted Around People</h2>
        <p className="mt-6 text-gray-300 max-w-3xl mx-auto leading-relaxed">
          We are a mission-driven team focused on building digital ecosystems that empower businesses to act faster, understand deeper, and serve better. Every product we create blends innovation, empathy, and measurable impact.
        </p>
      </div>

      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {teamMembers.map(({ name, role, imageUrl, linkedin, email, portfolio }) => (
          <article key={name} className="group bg-gray-800/40 border border-gray-700/60 rounded-2xl p-4 text-center transition-transform duration-300 hover:-translate-y-2">
            <div className="mx-auto mb-6 h-24 w-24 overflow-hidden rounded-full bg-gradient-to-br from-indigo-600/70 via-purple-500/50 to-blue-500/50 border border-indigo-400/40">
              <img 
                src={imageUrl} 
                alt={`Profile of ${name}`} 
                className="h-full w-full object-cover" 
              />
            </div>
            <h3 className="text-xl font-semibold text-white">{name}</h3>
            <div className="team-member-links">
              <div className="team-social-icons">
                <a href={linkedin} target="_blank" aria-label="LinkedIn Profile" rel="noreferrer">
                  <i className="fab fa-linkedin" />
                </a>
                <a href={`mailto:${email}`}  target="_blank" aria-label="Send an Email" rel="noreferrer">
                  <i className="fas fa-envelope" />
                </a>
              </div>
              <a href={portfolio} target="_blank" className="portfolio-button" rel="noreferrer">Personal Portfolio</a>
            </div>
            <p className="mt-2 text-sm text-gray-400">{role}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default AboutSection;
